import React from "react";
import Box from "@mui/material/Box";
import { NavLink } from "react-router-dom";
import AppTitleLogo from "../../assets/images/projam-icon.svg";
import footerLinksData from "./footer.json";
import "./footer.scss";

const { footer_links } = footerLinksData;

/** Always the real current year — no hard-coded date to go stale. */
const getCurrentYear = () => new Date().getFullYear();

const Footer = () => (
  <Box component="footer" className="pj-footer">
    <div className="ft-wrap">
      <div className="ft-top">
        <div>
          {/* the same mark the header uses, shown once */}
          <NavLink to="/" className="ft-brand-link" aria-label="Projam home">
            <img src={AppTitleLogo} alt="Projam" />
            <span className="ft-wordmark">Projam</span>
          </NavLink>
          <p className="ft-tagline">
            Streamline your projects, empower your teams.
          </p>
        </div>

        <nav className="ft-nav" aria-label="Footer">
          {footer_links.map((link) => (
            <NavLink key={link.label} to={link.to} className="ft-link">
              {link.label}
            </NavLink>
          ))}
        </nav>
      </div>

      <div className="ft-bottom">
        <p className="ft-copy">
          © {getCurrentYear()} Projam. All rights reserved.
        </p>
      </div>
    </div>
  </Box>
);

export default Footer;
